import { Colors, htmlToSlate, RichText, Text } from '@amelio/ui-library';

import { htmlToPlainText } from '@/utils/htmlSanitizer';

interface ReadOnlyNotesProps {
    /** The notes as stored, in HTML; `null` or blank when nothing was written. */
    content: string | null;
    /** Said in place of the notes when nothing was written. */
    emptyMessage: string;
    ariaLabel: string;
    language: string;
    dataTestId: string;
}

/**
 * The notes of a completed meeting: shown as text, with no field, prompt or character count, or,
 * when nothing was written, a sentence saying so. Only for notes already known: a caller still
 * waiting for them shows a placeholder, never this sentence.
 */
export const ReadOnlyNotes = ({
    content,
    emptyMessage,
    ariaLabel,
    language,
    dataTestId,
}: ReadOnlyNotesProps) => {
    const html = content ?? '';

    if (htmlToPlainText(html).trim() === '') {
        return <Text color={Colors.BASE_500}>{emptyMessage}</Text>;
    }

    return (
        // Keyed by the notes: `RichText` reads its document once, so new notes mount a new one.
        <RichText
            key={html}
            value={htmlToSlate(html)}
            readOnly
            toolbar={false}
            contentMinHeight={'auto'}
            ariaLabel={ariaLabel}
            locale={language}
            dataTestId={dataTestId}
        />
    );
};
